import * as React from 'react';
import { STATE } from 'app/constants';
import { containerFactory } from 'app/infrastructure/redux/index';
import { actionCreators } from './actions';
import { PromptConfirmation, ButtonCallToAction, Paper } from 'ui';
import { UserDefaultValuesState } from './types';
import { ElementLoader } from 'ui/common/element-loader/element-loader';
import { simpleFieldForPath, withSimpleForm } from 'app/infrastructure/simple-form';
import { withPrompt } from 'app/components/prompt-unsaved/prompt-unsaved';
import { UserDefaultValuesProps } from './types';
import { AccessPanel } from './access-panel';
import { ids } from 'app/area/administration/constants';
import { OverlayComponent } from 'app/components/overlay/overlay';
import { serializeAccessData } from './serialize';
import { userDefaultValuesTranslations } from 'app/area/user-profile/default-values/constants';
import { compareAccess } from 'app/area/administration/edit/compare-access';
import { ScrollToTop } from 'ui/scroll-to-top/scroll-to-top';
import { UserProfileHeading } from 'app/area/user-profile/user-profile-heading';
import { UserProfileSectionHeading } from 'app/area/user-profile/user-profile-section-heading';

import type { JSX } from "react";

const SimpleForm = simpleFieldForPath(STATE.userDefaultValues);

export class UserDefaultValuesComponent extends React.Component<UserDefaultValuesProps> {
  public static statePath: string = STATE.userDefaultValues;

  public componentWillUnmount() {
    this.props.clearDefaultValues();
  }

  public componentDidMount() {
    this.props.loadRole();
    this.props.loadDefaultValues();
  }

  private performDefaultValues = () => {
    const { saveDefaultValues, accessData } = this.props;

    saveDefaultValues(serializeAccessData(accessData).defaultValues, () => {
      this.props.loadRole();
      this.props.loadDefaultValues();
    });
  };

  public render(): JSX.Element {
    const { data, translation, fetchingLoadDefaultValues, fetchingSaveDefaultValues } = this.props;

    const shouldRender = !fetchingLoadDefaultValues && data;

    return <Paper componentId={'default-values-paper'} className="user-profile-section-paper">
      <UserProfileHeading title={translation.main_title} />
      <UserProfileSectionHeading sectionTitle={translation.default_values} />
      <section>
        <div className="main-grid">
          <OverlayComponent
            displayOverlay={fetchingSaveDefaultValues}
            overlayText={translation.save_user_load_overlay_text} />
          {this.props.shouldDisplayModal
            ? <PromptConfirmation
              title={translation.cancel_changes}
              description={translation.are_you_sure}
              continueText={translation.undo_all}
              cancelText={translation.go_back}
              onContinue={this.props.continue}
              onCancel={this.props.cancel}
            />
            : ''}
          {!shouldRender
            ? <ElementLoader />
            : <AccessPanel
              formComponent={SimpleForm}
              {...this.props} />}

          <div className="row">
            <div className="col-sm-6" />
            <div className="col-sm-6">
              <div className="text-end">
                <ButtonCallToAction
                  id={ids.users.save_button}
                  onClick={this.performDefaultValues}
                  disabled={fetchingSaveDefaultValues || !shouldRender}>
                  {translation.save}
                </ButtonCallToAction>
              </div>
            </div>
          </div>
        </div>
      </section>
      <ScrollToTop />
    </Paper>;
  }
}

const selectors = {
  shouldPrompt: ({ data, accessData }: UserDefaultValuesState) => compareAccess(serializeAccessData(accessData), data)
};

const container = withSimpleForm(containerFactory(withPrompt(UserDefaultValuesComponent),
  actionCreators, selectors, userDefaultValuesTranslations));

export { container as UserDefaultValues };
